import { render, staticRenderFns } from "./BreadcrumbNode.vue?vue&type=template&id=526db974&scoped=true&"
import script from "./BreadcrumbNode.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbNode.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbNode.vue?vue&type=style&index=0&id=526db974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526db974",
  null
  
)

export default component.exports